import ExitFreespins from "slotworks/state-machine/standard/states/exit-freespins";
import Layers from "slotworks/graphics/layers/layers";
import deviceInfo from "slotworks/utils/device-info";
import soundManager from "slotworks/sound/sound-manager";
import Components from "slotworks/components/components";
import MessagesComponent from "components/messages/messages-component";
import Contract from "slotworks/utils/contract";
import { parallel } from "slotworks/utils/race-utils";
import G288PromptContent from "components/prompt/prompt-content";
import smartButton, { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import gameState from "slotworks/model/game-state";
import G288FreespinRecord from "integration/freespin-record";
import G288SpinReelTransition from "components/matrix/transitions/spin-reel-transition";

export default class G288ExitFreespins extends ExitFreespins {

    protected exitPrompt: G288PromptContent;

    public onEnter() {
        setTimeout(() => {
            if(!deviceInfo.isDesktop) Layers.SmartButton.hide();
            super.onEnter();
        }, 1000);
    }

    public complete() {
        this.fixScattersLayer();
        soundManager.customEvent("base_music");
        (Components.footer as MessagesComponent).onExitFreespins();
        super.complete();
    }

    protected setupPrompt() {
        return Contract.wrap(() => {
            smartButton.setFlag(SmartButtonFlag.PROMPT, true);

            const freeSpinsWin = gameState.getCurrentGame().getRunningFreespinsWinTotal();
            const summaryScene = "freespinssummary";

            const freespinsRecord = gameState.getCurrentGame().getCurrentRecord() as G288FreespinRecord;
            const freespinsPlayed = freespinsRecord.totalFreespins.toString();

            this.exitPrompt = new G288PromptContent([summaryScene, ...this.summaryScenes], 4000);
            this.exitPrompt.addContinueButton("continue");

            this.promptContents.set("played", freespinsPlayed);
            this.exitPrompt.addText(this.promptContents);

            this.exitPrompt.countupText("value", freeSpinsWin, 2000);
        });
    }

    protected showPrompt() {
        soundManager.customEvent("freespins_result");
        Layers.CelebrationBackground.setScene("freespins").execute();
        return Components.prompt.showPrompt(this.exitPrompt);
    }

    protected afterPrompt() {
        Layers.CelebrationBackground.defaultScene().execute();
        Layers.SmartButton.show();
        const reelTransition = Components.matrix.getTransition() as G288SpinReelTransition;
        reelTransition.resetReelset();
        return super.afterPrompt();
    }

    protected hideFreespinsComponents(): Contract<void> {
        return parallel([
            () => Layers.Background.defaultScene(),
            () => Layers.Header.defaultScene(),
            () => Contract.wrap(() => Components.banner.setMode("default")),
            () => Contract.wrap(() => Components.footer.showDefaultText())
        ]);
    }

    private fixScattersLayer() {
        if (!gameState.getCurrentGame().isRecovered) {
            Components.matrix.getGridSymbols().forEach((symbol) => {
                if(symbol.symbolId == "SCATTER") {
                    symbol.setLayer(Layers.SymbolAnimations);
                    symbol.lockLayer();
                }
            })
        }
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/exit-freespins.ts